import {redirect} from "react-router-dom";
import ReasonCategories from "../../../services/UkTreatmentApi/ReasonCategories";

export async function action({params}) {
    await ReasonCategories.delete(params.reasonCategoryId);

    return redirect("/manage/reason_categories");
}